import { defaultContainerElements } from '../defaults';
import { handleFontFamilyFallbacks } from './handle-font-family-fallbacks';
import { injectMobileLineHeightClass } from './inject-mobile-line-height-class';
import { inlineFontSize } from './inline-font-size';
import { recalculateLetterSpacing } from './recalculate-letter-spacing';
import { recalculateLineHeight, lineHeightExplicitInheritance, } from './recalculate-line-height';
import { injectMobileFontSizeClass } from './inject-mobile-font-size-class';
export var defaultContainerMissingPropsInjectorFactory = function () {
    return {
        elements: defaultContainerElements,
        mutators: [
            handleFontFamilyFallbacks,
            inlineFontSize,
            recalculateLineHeight,
            injectMobileFontSizeClass,
            recalculateLetterSpacing,
            injectMobileLineHeightClass,
        ],
    };
};
export var explicitInheritanceFactory = function () { return ({
    elements: defaultContainerElements,
    mutators: [lineHeightExplicitInheritance],
}); };
//# sourceMappingURL=inject-missing-props-into-default-containers.js.map